





















































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { SchoolGroupCompetencyRanking } from '@/models/school-group/school-group-competency-ranking';
import { groupModule } from '@/store/modules/entities/group.module';
import GClassManagementShowCompetencySetting from '@/views/GClassManagement/GClassManagementShowCompetencySetting.vue';
import GClassManagementCompetencyAllRankCard from '@/views/GClassManagement/GClassManagementCompetencyAllRankCard.vue';

@Component({
  name: 'GClassManagementCompetencyAllRanking',
  components: {
    GClassManagementShowCompetencySetting,
    GClassManagementCompetencyAllRankCard,
  },
})
export default class GClassManagementCompetencyAllRanking extends mixins(GPageBase) {
  showAllCompetencyRankingModal: boolean = false;
  showAllCompetencyGrowthRankingModal: boolean = false;
  competencyID: number = 0;

  mounted() {}

  get competencyRankingByType(): SchoolGroupCompetencyRanking[] {
    return groupModule.competencyRankingByType.slice().sort(function (first: SchoolGroupCompetencyRanking, second: SchoolGroupCompetencyRanking) {
      return first.competencyID - second.competencyID;
    });
  }

  get competencyItem(): SchoolGroupCompetencyRanking {
    if (this.competencyID === 0 && this.competencyRankingByType[0]) {
      this.competencyID = this.competencyRankingByType[0].competencyID;
      return this.competencyRankingByType[0];
    } else {
      return this.competencyRankingByType.find(competency => competency.competencyID === this.competencyID);
    }
  }

  handleCloseRankingModal(): void {
    this.showAllCompetencyRankingModal = false;
    this.competencyID = 0;
  }

  handleCloseGrowthRankingModal(): void {
    this.showAllCompetencyGrowthRankingModal = false;
    this.competencyID = 0;
  }

  goToCompetencyRankingDetails(): void {
    this.showAllCompetencyRankingModal = true;
  }

  goToCompetencyRankingGrowthDetails(): void {
    this.showAllCompetencyGrowthRankingModal = true;
  }
}
